import { DeleteOutline } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { MemoryBook } from "../../../../../types/memory-table";

interface MemoryBookTableRowProps {
  memoryBook: MemoryBook;
  onDelete: (memoryBookId: number) => void;
  isMobile?: boolean;
}

export const MemoryBookTableRow: React.FC<MemoryBookTableRowProps> = ({
  memoryBook,
  onDelete,
  isMobile = false,
}) => {
  const date = new Date(memoryBook.created_at).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const determineUploadedName = (): string => {
    if (!memoryBook.created_by) {
      return "Unknown";
    }
    if (
      !memoryBook.created_by.first_name ||
      !memoryBook.created_by.last_name
    ) {
      return memoryBook.created_by.username;
    }
    return `${memoryBook.created_by.first_name} ${memoryBook.created_by.last_name}`;
  };

  const fileName = memoryBook.file
    ? memoryBook.file.split("/").at(-1)
    : "No file uploaded";


  if (isMobile) {
    return (
      <Card variant="outlined" sx={{ borderRadius: 2 }}>
        <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 1,
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="body2"
                fontWeight={600}
                noWrap
                sx={{ fontSize: "0.8rem" }}
              >
                {fileName}
              </Typography>
              <Typography variant="caption" display="block" sx={{ opacity: 0.7 }}>
                {determineUploadedName()}
              </Typography>
              <Typography variant="caption" display="block" sx={{ opacity: 0.6 }}>
                {date}
              </Typography>
            </Box>
            <IconButton
              color="error"
              size="small"
              onClick={() => onDelete(memoryBook.id)}
              sx={{ flexShrink: 0 }}
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Box>
        </CardContent>
      </Card>
    );
  }


  return (
    <TableRow
      key={memoryBook.id}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell>{fileName}</TableCell>
      <TableCell>{determineUploadedName()}</TableCell>
      <TableCell>{date}</TableCell>
      <TableCell>
        <IconButton
          color="error"
          size="small"
          onClick={() => onDelete(memoryBook.id)}
        >
          <DeleteOutline fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

MemoryBookTableRow.propTypes = {
  memoryBook: PropTypes.shape({
    id: PropTypes.number.isRequired,
    created_at: PropTypes.string.isRequired,
    created_by: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      username: PropTypes.string,
    }),
    file: PropTypes.string,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};